<template>
  <slot :paste="pasteElement">
    <v-btn
      v-if="condition"
      absolute
      class="mt-2 text-capitalize"
      :class="extraClasses"
      color="primary"
      flat
      prepend-icon="mdi-content-paste"
      rounded="xl"
      variant="outlined"
      @click="pasteElement()"
      :data-cy="dataCy">
      {{
        $t("actions.paste", {
          element: mainStore.copyData.name
        })
      }}
    </v-btn>
  </slot>
</template>

<script lang="ts" setup>
import { useSpaceStore } from "@/stores/spaceStore";
import { useMainStore } from "@/stores/mainStore";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import allowedChildren from "@/data/raw/allowedChildren.json";

const { t } = useTranslation();
const createConfirm = useConfirm();

const spaceStore = useSpaceStore();
const mainStore = useMainStore();

const createSnackbar = useSnackbar();
const route = useRoute();

const props = defineProps({
  condition: {
    type: Boolean,
    default: true
  },
  dataCy: {
    type: String,
    default: "paste-button"
  },
  extraClasses: {
    type: String,
    default: ""
  }
});

async function copyLocation() {
  if (
    mainStore.copyData.spaceId !== mainStore.activeSpaceId &&
    (mainStore.copyData.id.endsWith("_part") ||
      mainStore.copyData.id.endsWith("_folder")) &&
    mainStore.copyData.locations.length
  ) {
    return createConfirm({
      dialogProps: { width: 400 },
      cardProps: { color: "green" },
      title: t(`actions.confirmation.copy-location.title`),
      content: t(`actions.confirmation.copy-location.content`),
      confirmationText: t(`actions.confirmation.copy-location.confirm`),
      cancellationText: t(`actions.confirmation.copy-location.cancel`),
      confirmationButtonProps: {}
    }).then((confirm) => {
      return !!confirm;
    });
  } else {
    return Promise.resolve(false);
  }
}

async function pasteElement() {
  console.log("copyData", JSON.stringify(mainStore.copyData));
  if (!mainStore.copyData.id) {
    // nothing to paste
    return;
  }

  const [, copyType] = mainStore.copyData.id.split("_");

  let nodeId: string | undefined = route.params.nodeId as string | undefined;

  const location = await copyLocation();
  if (nodeId) {
    const [, type] = nodeId.split("_");

    if (copyType === "folder") {
      spaceStore.cloneOnServer(undefined, location);
    } else if (allowedChildren[type]?.includes(copyType)) {
      if (type === copyType && copyType === "part") {
        spaceStore.cloneOnServer(nodeId, location, true);
      } else {
        nodeId = nodeId.replace("manufacturingStep", "part");
        spaceStore.cloneOnServer(nodeId, location);
      }
      // mainStore.copyData.id = null;
    } else {
      createSnackbar({
        text: "Element kann hier nicht eingefügt werden",
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 2000 }
      });
    }
  } else if (copyType === "folder") {
    spaceStore.cloneOnServer(undefined, location);
  }
}
</script>
